export enum IconSize {
  SM = 16,
  MD = 24,
  LG = 32,
}

export type IconsFolderL1 =
  | 'actions'
  | 'assets'
  | 'communication'
  | 'files'
  | 'my-account'
  | 'people'
  | 'priorities'
  | 'status'
  | 'system'
  | 'tasks';

// rough icons type produced from the media folders using:
// find . -type f -not -path "*.png" | sed -e 's/\/[0-9][0-9]px.svg$//' | awk '!NF || !seen[$0]++' | sort -n
export type IconsSubFolder =
  | '01-close'
  | '02-add'
  | '03-remove'
  | '04-delete'
  | '05-copy'
  | '06-chevron-up'
  | '07-chevron-down'
  | '08-chevron-right'
  | '09-chevron-left'
  | '10-view-options'
  | '11-new-page'
  | '12-search'
  | '13-rating-empty'
  | '14-rating-half'
  | '15-rating-full'
  | '16-open-task'
  | '17-close-task'
  | '18-merge-tasks'
  | '19-upload-files'
  | '20-download-files'
  | '21-view-text'
  | '22-hide-text'
  | '23-filter'
  | 'asset-details/01-description'
  | 'asset-details/02-address'
  | 'asset-details/03-privacy-public'
  | 'asset-details/04-privacy-registered'
  | 'asset-details/05-privacy-restricted'
  | 'asset-details/06-privacy-private'
  | 'asset-details/07-share'
  | 'asset-details/08-management'
  | 'asset-details/09-asset-details'
  | 'asset-details/10-asset-settings'
  | 'asset-details/11-importance'
  | 'asset-details/12-specific-service-level'
  | 'asset-details/13-onsite-assistant-link'
  | 'asset-types/bedroom'
  | 'asset-types/bicycle-storage'
  | 'asset-types/building'
  | 'asset-types/development'
  | 'asset-types/flat'
  | 'asset-types/furniture'
  | 'asset-types/garage'
  | 'asset-types/house'
  | 'asset-types/motorbike-parking'
  | 'asset-types/park'
  | 'asset-types/parking'
  | 'asset-types/region'
  | 'asset-types/road'
  | 'attach'
  | 'received'
  | 'send'
  | '01-image'
  | '02-audio'
  | '03-video'
  | '04-PDF'
  | '05-text-document'
  | '06-contract'
  | '07-manual'
  | '01-personal-details'
  | '02-login-and-security'
  | '03-notification-preferences'
  | '05-global-user'
  | 'people-details/01-mobile'
  | 'people-details/02-email'
  | 'people-details/03-user-preferences'
  | 'people-details/04-login-security'
  | 'people-types/01-client-admin'
  | 'people-types/02-super-agent'
  | 'people-types/03-agent'
  | 'people-types/04-super-owner'
  | 'people-types/05-owner'
  | 'people-types/06-super-service-user'
  | 'people-types/07-service-user'
  | 'people-types/08-super-supplier'
  | 'people-types/09-supplier'
  | 'P1'
  | 'P10'
  | 'P2'
  | 'P3'
  | 'P4'
  | 'P5'
  | 'P6'
  | 'P7'
  | 'P8'
  | 'P9'
  | '01-general/01-in-progress'
  | '01-general/02-success-circle'
  | '01-general/03-warning-triangle'
  | '01-general/04-error-circle'
  | '01-general/05-information-circle'
  | '01-general/06-tick'
  | '01-general/07-notification-bell'
  | '01-general/08-notification-dot'
  | '01-general/09-globe'
  | '02-task-details/01-task-status'
  | '02-task-details/02-SLA-normal'
  | '02-task-details/03-SLA-warning'
  | '02-task-details/04-SLA-breach'
  | '03-asset-details/01-status-live'
  | '03-asset-details/02-status-draft'
  | '01-tasks'
  | '02-assets'
  | '03-people'
  | '04-dashboard'
  | '05-notifications'
  | '06-user'
  | '07-teams'
  | '08-organisations'
  | '09-history'
  | '10-registration-token'
  | '11-settings'
  | '12-assistant'
  | '13-time'
  | 'menu'
  | 'task-details/01-to-do'
  | 'task-details/02-task-details'
  | 'task-details/03-messages'
  | 'task-details/04-notes'
  | 'task-details/05-pinned-note'
  | 'task-types/access'
  | 'task-types/alarm'
  | 'task-types/bathroom'
  | 'task-types/bicycle'
  | 'task-types/cleaning'
  | 'task-types/door'
  | 'task-types/dry-cleaning'
  | 'task-types/dryer'
  | 'task-types/electricity'
  | 'task-types/emergency'
  | 'task-types/fire'
  | 'task-types/fix'
  | 'task-types/flooding'
  | 'task-types/flowers'
  | 'task-types/food'
  | 'task-types/frozen'
  | 'task-types/garage'
  | 'task-types/garden'
  | 'task-types/gas'
  | 'task-types/insurance'
  | 'task-types/internet'
  | 'task-types/lift'
  | 'task-types/lights'
  | 'task-types/no-water'
  | 'task-types/noise'
  | 'task-types/painting'
  | 'task-types/parking'
  | 'task-types/payment'
  | 'task-types/pests'
  | 'task-types/plumbing'
  | 'task-types/roof'
  | 'task-types/temperature'
  | 'task-types/washer'
  | 'task-types/waste'
  | 'task-types/windows';
